<template>
  <div 
    v-hammer:swipe.horizontal="swipe"
    id="app"
    :class="{ 'ie' : isIe(), 'edge' : isEdge() }"
  >
    <header id="header">

      <div class="wrapper">
        <div>
          <div class="wrapper__inner">
            
            <img src="~images/svgs/logo.svg" @click.prevent="closeReadingAndNavigateToPage('')">


            <button :class="{ 'hamburger': true,  'hamburger--3dx': true, 'is-active': menuOpen }" type="button" @click="menuOpen = !menuOpen">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>            

          </div>
        </div>
      </div>

    </header>

    <transition :name="navigationDirection">
      <router-view 
        :key="$route.fullPath" 
        :menu-open="menuOpen"
      ></router-view>
    </transition>

    <aside id="menu" :class="{ sidebar: true, 'sidebar--open': menuOpen} ">
      
      <nav class="sidebar__content">

        <!--<section class="sidebar__home-nav">
          <div v-if="!firstPage">
            <button class="icon-before" @click="menuOpen = !menuOpen; closeReadingAndNavigateToPage('page/1/index.html')"><span class="icon-ccw">Cover</span></button>
          </div>
          <div>
            <button class="icon-before">
              <span class="oicon-arrow-down">PDF</span>
            </button>
          </div>
        </section>-->
  

        <ul class="nav-items">
          <li 
            v-for="(item, index) in content" 
            v-if="index > 0 && (index + 1) < content.length"
            v-bind:key="index" 
            @click="menuOpen = !menuOpen; closeReadingAndNavigateToPage('page/'+(index+1)+'/index.html')"
            v-html="item.title"
          ></li>
        </ul>
      </nav>
      <section class="sidebar__social">
        
        <section>
          Share: 
          <span class="icon-twitter" @click="shareContent('twitter', 'Your Tomorrow, Today is a magazine about innovation. We tell the stories of companies who push the envelope ', false)"></span>
          <span class="icon-facebook" @click="shareContent('facebook', 'Your Tomorrow, Today is a magazine about innovation. We tell the stories of companies who push the envelope ', false)"></span>
          <span class="icon-linkedin" @click="shareContent('linkedin', 'Your Tomorrow, Today is a magazine about innovation. We tell the stories of companies who push the envelope ', false)"></span>    
        </section>            

      </section>

    </aside>
    <div id="consentContainer"><span id="teconsent"></span></div>
  </div>
</template>

<script>
  
  // import our vuex state management
  import store from '@/store';

  // mixins
  import ShareContent from '@/mixins/shareContent';
  import NavigatePages from '@/mixins/navigatePages';
  
  export default {
    name: 'app',
    data(){
      return {
        menuOpen: false,
        content: store.getters.getAllPageContent,
        allContent: store.getters.getAllPageContent,
        cookieNotice: null   
      }
    },
    mixins: [ ShareContent, NavigatePages ],
    computed: {

      navigationDirection() {
        return store.getters.getCurrentPageDirection === 1 ? 'nextPage' : 'prevPage';
      },

      firstPage() {
        return parseInt(this.$route.params.pageid) === 1
      },

      pageId() {
        return parseInt(this.$route.params.pageid) || null
      },

      managingCookies: () => store.getters.getManagingCookies

    },

    watch: {

      managingCookies() {
        if (this.managingCookies) {
          const el = document.querySelector('#teconsent > a');
          this.triggerEvent(el, 'click');
          // and reset the state
          store.dispatch('manageCookies', false);
        }
      }

    },

    methods: {
 
      isIe() {

        const ua = window.navigator.userAgent;

        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
          // IE 10 or older => return version number
          return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
          // IE 11 => return version number
          const rv = ua.indexOf('rv:');
          return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        // other browser
        return false;


      },

      isEdge() {

        const ua = window.navigator.userAgent;
        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
          // Edge (IE 12+) => return version number
          return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        return false;


      },

      swipe(data) {

        if (data.deltaX < 0) {
          
          if (this.allContent[this.pageId]) {
            this.navigateThroughPages(1);     
          }
        
        } else if (data.deltaX > 0) {

          if (this.pageId > 1) {
            this.navigateThroughPages(-1);
          }

        }
      },

      triggerEvent(el, type){
          const event = document.createEvent('HTMLEvents');
          event.initEvent(type, false, true);
          el.dispatchEvent(event);
      },
      
      addCookieNotice() {

        if (window['__PRERENDER_INJECTED']) {
          return;
        }

        // let src = '//consent.truste.com/notice?domain=oracle.com&c=teconsent&js=bb&noticeType=bb&text=true&cacheBuster='
        // src += Math.ceil(Math.random()*100000000000);

        // const cookieStatus = store.getters.getCookieNoticeInjected;

        // if (cookieStatus) {
        //   return;
        // }


        this.cookieNotice = document.createElement('script');    
        this.cookieNotice.setAttribute('src', '//consent.truste.com/notice?domain=oracle.com&c=teconsent&js=bb&noticeType=bb&text=true');
        this.cookieNotice.setAttribute('async',"async");
        this.cookieNotice.setAttribute('crossorigin',"");
        document.head.appendChild(this.cookieNotice);  
        // get the content we want to use for the cookie preferences link
        
      }


    },

    mounted() {

      this.addCookieNotice();

    }
  };
</script>

<style lang="scss">

  @import './scss/app.scss'

</style>